import "./filters.scss";

import React, { useState } from "react";
import Checkbox from "components/Checkbox/Checkbox";
import RangeInput from "components/RangeInput/RangeInput";

const Box = ({ title, options }) => {
  return (
    <div className="filters__box">
      <div className="filters__box-title">{title}</div>
      {options?.map((option, index) => {
        return (
          <div className="filters__single-check-wrapper" key={index}>
            <Checkbox
              label={option.label}
              value={option.value}
              onChange={option.onChange}
              id={option.id ? option.id : option.label}
              checked={option.checked}
            />
            <div className="filters__count">{option.count}</div>
          </div>
        );
      })}
    </div>
  );
};

const FiltersCheckbox = ({
  handleTypes,
  handleConditions,
  handleBuildings,
  handlePrice,
  vehiclesLength,
  trailersLength,
  newVehiclesLength,
  usedVehiclesLength,
  integraLength,
  polIntegraLength,
  kamperVanLength,
  handlePage,
  brands,
  brandsCounts,
  handleBrands,
  showUsedOnStart,
}) => {
  const [price, setPrice] = useState({ min: 0, max: 900 });

  const handleRange = (priceMin, priceMax) => {
    setPrice({ min: priceMin, max: priceMax });
  };

  return (
    <div className="filters">
      <Box
        title="Kategoria"
        options={[
          {
            label: "Kamper",
            value: "vehicle",
            count: vehiclesLength,
            onChange: (e) => {
              handleTypes("vehicle");
              handlePage();
            },
          },
          {
            label: "Przyczepa",
            value: "trailer",
            count: trailersLength,
            onChange: (e) => {
              handleTypes("trailer");
              handlePage();
            },
          },
        ]}
      />
      <Box
        title="Stan"
        options={[
          {
            label: "Nowy",
            value: "new",
            count: newVehiclesLength,
            onChange: (e) => {
              handleConditions("new");
              handlePage();
            },
          },
          {
            label: "Używany",
            value: "used",
            count: usedVehiclesLength,
            onChange: (e) => {
              handleConditions("used");
              handlePage();
            },
            checked: showUsedOnStart,
          },
        ]}
      />
      <Box
        title="Marka"
        options={brands?.map((node) => {
          return {
            label: node.name,
            value: node.name,
            // count: brandsCounts[node.name],
            onChange: (e) => {
              handleBrands(node.name);
              handlePage();
            },
          };
        })}
      />
      <Box
        title="Zabudowa - kampery"
        options={[
          {
            label: "Kamper-van",
            value: "kampervan",
            count: kamperVanLength,
            onChange: (e) => {
              handleBuildings("kampervan");
              handlePage();
            },
          },
          {
            label: "Pół-integra",
            value: "polintegra",
            count: polIntegraLength,
            onChange: (e) => {
              handleBuildings("polintegra");
              handlePage();
            },
          },
          {
            label: "Integra",
            value: "integra",
            count: integraLength,
            onChange: (e) => {
              handleBuildings("integra");
              handlePage();
            },
          },
          {
            label: "Alkowy",
            value: "alkowy",
            count: integraLength,
            onChange: (e) => {
              handleBuildings("alkowy");
              handlePage();
            },
          },
        ]}
      />
      <RangeInput handlePrice={handlePrice(price)} handleRange={handleRange} />
    </div>
  );
};

export default FiltersCheckbox;
